"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const pulse_components_1 = require("@pcs/pulse-components");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const defaultData_1 = require("../../../reviews-modal/components/ShareForReview/Overview/defaultData");
const SegmentedControl = ({ items, value, onChange, isReadOnly = false, disableWhenOption = false, }) => {
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['segmented-container'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['segmented-label'] },
            react_1.default.createElement("label", null, "Stage Trigger"),
            react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                    content: (react_1.default.createElement("span", { style: { whiteSpace: 'pre-line' } }, defaultData_1.stageTriggerTooltip)),
                    popperOptions: {
                        strategy: 'fixed',
                    },
                    placement: 'top',
                } },
                react_1.default.createElement("i", { className: 'fal fa-info-circle' }))),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['segmented-buttons'] },
            react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                    content: 'Trigger settings cannot be changed while this stage is in progress.',
                    popperOptions: {
                        strategy: 'fixed',
                    },
                    placement: 'top',
                    trigger: 'mouseenter',
                    disabled: !isReadOnly,
                } }, items.map((item) => {
                const isActive = item.value === value;
                return (react_1.default.createElement("button", { key: item.value, className: (0, clsx_1.default)(styles_modules_less_1.default['segmented-item'], {
                        [styles_modules_less_1.default.active]: isActive,
                    }), onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(item.value), type: "button", disabled: isReadOnly || (item.value === 'when' && disableWhenOption) },
                    (item === null || item === void 0 ? void 0 : item.icon) && react_1.default.createElement("i", { className: item === null || item === void 0 ? void 0 : item.icon }),
                    react_1.default.createElement("span", { className: styles_modules_less_1.default.label }, item.title)));
            })))));
};
exports.default = SegmentedControl;
